import { useDialog } from "@datanac/datanac-mui-toolkit/dist/hooks";
import { Chip, IconButton } from "@mui/material";
import { TilleyCard } from "components/Cards/TilleyCard";
import { DeleteIcon, MoneyIcon } from "components/Icons/Icons";

import { formatNumber } from "../../utility/formatters";

export default function DebtCard({ debt, onClick, onDelete }) {
  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();

  const handleDeleteClick = () => {
    confirmDialogActions.confirm({
      title: "Delete this debt entry?",
      prompt: `Are you sure you want to delete "${debt.creditor}"?`,
      promptDetail: "This action cannot be undone.",
      callback: () => {
        onDelete?.(debt);
      },
    });
  };

  return (
    <>
      <TilleyCard
        onClick={onClick}
        Avatar={MoneyIcon}
        title={debt.category}
        subtitle={debt.name || debt.creditor}
        action={
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteClick();
            }}
          >
            <DeleteIcon />
          </IconButton>
        }
        details={[
          {
            value:
              debt.liability_current !== undefined && debt.liability_current !== null
                ? `$ ${formatNumber(debt.liability_current, 0)}`
                : "—",
            label: "Current Liability",
          },
          {
            value:
              (debt.liability_intermediate !== undefined && debt.liability_intermediate !== null) ||
              (debt.liability_longterm !== undefined && debt.liability_longterm !== null)
                ? `$ ${formatNumber(debt.liability_intermediate || debt.liability_longterm || 0, 0)}`
                : "—",
            label: "Long-Term Liability",
          },
        ]}
        footer={debt.purpose && <Chip label={debt.purpose} />}
      />

      {confirmDialogComponent}
    </>
  );
}
